import { Download } from "lucide-react"
import { useEffect, useState } from 'react'
import InnerHeader from "@/components/InnerHeader"
import Footer from "@/components/Footer"
import { useParams } from 'react-router-dom';
import { productApi } from "@/http/apiList"

export default function ConceptSectorPage() {
  const { productKey } = useParams();
  const  [ detail, setDetail ] = useState({})
  const getProductDetail = async () => {
    const data = await productApi.getProductList({ key: productKey })
    setDetail(data.data);
  }
  useEffect(() => {
   getProductDetail();
  }, []);

  return (
    <div className="bg-white flex flex-col min-h-screen">
      {/* Header */}
      <InnerHeader></InnerHeader>
      {/* Main Content */}
      <main className="flex-grow container container-max-w mx-auto px-4 py-16">
        <h1 className="text-4xl font-semibold text-gray-800 mb-12">{ detail.title }</h1>

        <div className="space-y-6 text-gray-700 leading-relaxed">
          <p>{detail.content}</p>
        </div>

        {/* <div className="mt-12 pt-8 border-t border-gray-200 space-y-6">
          <a href="#" className="inline-flex items-center text-blue-600 text-xl hover:underline underline-offset-4">
            <Download className="w-5 h-5 mr-3" />
            Data Dictionary (.csv)
          </a>
          <br />
          <a href="#" className="inline-flex items-center text-blue-600 text-xl hover:underline underline-offset-4">
            <Download className="w-5 h-5 mr-3" />
            Sample Data (.csv)
          </a>
        </div> */}
      </main>
      <Footer></Footer>
    </div>
  )
}
